import getUrlDict from './getUrlDict'

export function env() {
  const h = window.location.hostname
  const forcedEnv = getUrlDict().savvy_env
  if (h.startsWith('localhost')) return 'local'
  if (
    h.endsWith('cidemo.co') ||
    h.endsWith('branch.trysavvy.com') ||
    h.endsWith('branch.embeddables.com')
  ) {
    return 'ci'
  }
  if (h.endsWith('csb.app')) return 'branch'
  if (
    [
      'preview-dev.trysavvy.com',
      'preview-dev.heysavvy.workers.dev',
      'preview-dev.embeddables.com',
    ].includes(h)
  ) {
    return 'preview-dev'
  }
  if (
    [
      'preview-staging.trysavvy.com',
      'preview-staging.heysavvy.workers.dev',
      'preview-staging.embeddables.com',
    ].includes(h)
  ) {
    return 'preview-staging'
  }
  if (h === 'preview-ready-for-qa.trysavvy.com' || h === 'preview-ready-for-qa.embeddables.com') {
    return 'preview-ready-for-qa'
  }
  if (
    [
      'preview-side-staging.trysavvy.com',
      'preview-side-staging.heysavvy.workers.dev',
      'preview-side-staging.embeddables.com',
    ].includes(h)
  ) {
    return 'preview-side-staging'
  }
  if (
    h === 'preview-side-staging-2.trysavvy.com' ||
    h === 'preview-side-staging-2.embeddables.com'
  ) {
    return 'preview-side-staging-2'
  }
  if (
    h === 'preview-side-staging-3.trysavvy.com' ||
    h === 'preview-side-staging-3.embeddables.com'
  ) {
    return 'preview-side-staging-3'
  }
  if (
    [
      'preview.trysavvy.com',
      'preview.heysavvy.workers.dev',
      'stimulus-1-indexhtml.heysavvy.workers.dev',
      'preview.embeddables.com',
      'app.embeddables.com',
    ].includes(h) ||
    window.location.href.startsWith('https://app.embeddables.com/edit/')
  ) {
    return 'preview'
  }
  if (forcedEnv === 'dev') return 'dev'
  if (forcedEnv === 'ci') return 'ci'
  if (forcedEnv === 'staging') return 'staging'
  if (forcedEnv === 'side-staging') return 'side-staging'
  if (forcedEnv === 'side-staging-2') return 'side-staging-2'
  return 'production'
}
